package br.com.texeratx.boardgametimeapp.ui.screens.players.detail

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppScreenScaffold
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarTone
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import br.com.texeratx.boardgametimeapp.ui.screens.games.detail.GameDetailScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.detail.MatchDetailScreen
import br.com.texeratx.boardgametimeapp.ui.screens.players.edit.EditPlayerScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class PlayerDetailScreen(
    private val playerId: Long
) : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<PlayerDetailViewModel>()

        val player by viewModel.player.collectAsState()
        val isLoading by viewModel.isLoading.collectAsState()
        val error by viewModel.error.collectAsState()

        val uiMessage by viewModel.uiMessage.collectAsState()
        val isDeleting by viewModel.isDeleting.collectAsState()
        var showDeleteConfirmation by remember { mutableStateOf(false) }

        val navigator = LocalNavigator.currentOrThrow

        val snackbarHostState = remember { SnackbarHostState() }

        LaunchedEffect(uiMessage) {
            uiMessage?.let {
                snackbarHostState.showSnackbar(it)
                viewModel.uiMessage.value = null
            }
        }

        LaunchedEffect(navigator.lastItem) {
            viewModel.loadPlayer(playerId)
        }

        when {
            isLoading -> {
                Box(
                    Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    CircularProgressIndicator()
                }
            }

            error != null -> {
                Text("Erro: $error")
            }

            player != null -> {
                AppScreenScaffold(
                    snackbarHost = { SnackbarHost(snackbarHostState) }
                ) { innerPadding ->
                    PlayerDetailUI(
                        player = player!!,
                        contentPadding = innerPadding,
                        onEditClick = {
                            navigator.push(EditPlayerScreen(player!!.id))
                        },
                        onDeleteClick = { showDeleteConfirmation = true },
                        showDeleteConfirmation = showDeleteConfirmation,
                        isDeleting = isDeleting,
                        onDismissDeleteConfirmation = { showDeleteConfirmation = false },
                        onConfirmDelete = {
                            showDeleteConfirmation = false
                            viewModel.deletePlayer(playerId) {
                                navigator.pop()
                                AppUiEventBus.publishMessage(
                                    message = "Jogador exclu�do com sucesso.",
                                    tone = AppSnackbarTone.Success
                                )
                            }
                        },
                        onGameClick = { game ->
                            navigator.push(GameDetailScreen(game.id))
                        },
                        onMatchClick = { match ->
                            navigator.push(MatchDetailScreen(match))
                        }
                    )
                }
            }
        }
    }
}
